import log from "../utils/log";

import moment from "moment-timezone";
import { DepartureTimes } from "../transit_displays/departure_times.js";

export class AdminTransitIntegration {
  init() {
    if (window.integrationApiResponse) {
      this.initIntegrationDisplay();
    }
    this.toggleAgencyness();
    $("#transit_integration_provider").on("change", e => {
      this.toggleAgencyness();
    });
  }

  toggleAgencyness() {
    if (
      window.multiTransitAgencySlugs.includes(
        $("#transit_integration_provider").val()
      )
    ) {
      $(".showOnMultiAgency").collapse("show");
      $(".showOnSingleAgency").collapse("hide");
      $(
        ".showOnMultiAgency.required input, .showOnMultiAgency.required select"
      ).attr("required", true);
      $(
        ".showOnSingleAgency.required input, .showOnSingleAgency.required select"
      ).attr("required", false);
    } else {
      $(".showOnMultiAgency").collapse("hide");
      $(".showOnSingleAgency").collapse("show");
      $(
        ".showOnMultiAgency.required input, .showOnMultiAgency.required select"
      ).attr("required", false);
      $(
        ".showOnSingleAgency.required input, .showOnSingleAgency.required select"
      ).attr("required", true);
    }
  }

  initIntegrationDisplay() {
    // Set this so that we can render departureTimes
    window.currentTime = moment();
    window.departureTimes = new DepartureTimes(true, 10);

    this.renderTransitDeparture();

    // Watch for clicks to change what is rendered
    $(".integrationDisplaySelector").on("click", e => {
      e.preventDefault();
      const $target = $(e.target);
      if ($target.hasClass("display-only-this")) {
        $("#transit-integration-display")
          .removeClass("only-this-selected")
          .addClass("all-selected");
      } else {
        $("#transit-integration-display")
          .removeClass("all-selected")
          .addClass("only-this-selected");
      }
      this.renderTransitDeparture();
    });
  }

  renderTransitDeparture() {
    const allStops = $("#transit-integration-display").hasClass("all-selected");
    // Load departure times data
    (allStops ? window.stopAllApiResponse : window.stopApiResponse).forEach(
      stopData => {
        $("#routeDisplay").append(
          window.departureTimes.renderStopPane(stopData)
        );
      }
    );
  }
}
